import { useDrawer } from '@iveco-ti/iveco-ds'
import * as Sentry from '@sentry/react'
import { OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { PostModel } from '@/common/models/post'
import { useViewNewsStore } from '../stores/useViewNewsStore'

export function useViewNews() {
  const { open, close } = useDrawer('drawer-view-news')
  const { news, setNews } = useViewNewsStore()
  const { t } = useTranslation('panel')

  const viewNews = (news: PostModel | null) => {
    if (news?.post?.content || news?.postFile) {
      setNews(news)
      open()
      return
    }

    if (news?.postExternalUrl) {
      window.open(`https://${news.postExternalUrl}`, '_blank')
      return
    }

    toast(Toast, {
      data: {
        type: 'warning',
        icon: OctagonAlert,
        title: t('news.use_view_news.toast_error.title'),
        description: t('news.use_view_news.toast_error.description'),
      },
    })

    Sentry.captureMessage(`Unable to open news: ${news?.id}`, 'warning')
  }

  const closeNews = () => {
    setNews(null)
    close()
  }

  return { news: news, viewNews, closeNews }
}
